// extracted by mini-css-extract-plugin
export default {"container":"flex-layout_container__J9V2M"};